import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {firstValueFrom, Observable} from 'rxjs';
import {AuthActions, AuthState} from '../../models/auth';
import {Loader} from '../../models/loader/loader.redux';
import {Store} from '@ngxs/store';
import {MessageAlertService} from '../../services/message-alert/message-alert.service';
import {StorageService} from '../../services/storage/storage.service';

@Injectable({
  providedIn: 'root'
})
export class HasTokenGuard implements CanActivateChild {

  constructor(
    private router: Router,
    private store: Store,
    private messageAlertService: MessageAlertService,
    private storageService: StorageService,
  ) { }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return new Promise<boolean>(async (resolve, reject) => {
      const token = this.storageService.getLocalItem('token');
      if (!token) {
        // this.messageAlertService.createMessage('error', this.messageAlertService.messages.sessionExpired);
        await this.router.navigate(['auth/new/landing']);
        reject(new Error('Unauthenticated.'));
      } else {
        await firstValueFrom((this.store.dispatch(new AuthActions.IsLogged())));
        const isLogged = await firstValueFrom((this.store.selectOnce(AuthState.getIsLoggedOnly)));
        if (isLogged === true) {
          resolve(true);
        } else {
          // this.messageAlertService.createMessage('error', this.messageAlertService.messages.sessionExpired);
          await this.router.navigate(['auth/new/landing']);
          reject(new Error('Unauthenticated.'));
        }
      }
      await firstValueFrom((this.store.dispatch(new Loader(false))));
    });
  }
}
